// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__cT9sh","content":"styles_content__13EuT","selectAll":"styles_selectAll__2nBMN"};